type KnowledgeWhiteListConfig = Pick<
  General.WhiteListConfig,
  | 'ENABLE_SUPPLEMENT_KNOWLEDGE'
  | 'ENABLE_CHAT_HISTORY'
  | 'KNOWLEDGE_SINGLE_ITEM'
  | 'SHIPPING_AND_LOGISTICS'
  | 'BOOTGUIDE'
  | 'NEW_VERSION_PRODUCT_KNOWLEDGE'
>;

export const hasKnowledgePageAccess = (whiteListConfig: Partial<KnowledgeWhiteListConfig> = {}) => {
  const {
    ENABLE_SUPPLEMENT_KNOWLEDGE,
    ENABLE_CHAT_HISTORY,
    KNOWLEDGE_SINGLE_ITEM,
    SHIPPING_AND_LOGISTICS,
    BOOTGUIDE,
    NEW_VERSION_PRODUCT_KNOWLEDGE,
  } = whiteListConfig;

  return Boolean(
    ENABLE_SUPPLEMENT_KNOWLEDGE ||
      ENABLE_CHAT_HISTORY ||
      KNOWLEDGE_SINGLE_ITEM ||
      SHIPPING_AND_LOGISTICS ||
      BOOTGUIDE ||
      NEW_VERSION_PRODUCT_KNOWLEDGE,
  );
};

export const hasProductKnowledgeMenuAccess = (
  newVersionProductKnowledgeEnable?: boolean,
  legacyPermission = false,
) => Boolean(newVersionProductKnowledgeEnable || legacyPermission);
